var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vue-notification__center"},[_c('client-only',[_c('notifications',{attrs:{"duration":5000,"position":"top","group":"1","classes":"vue-notification-custom"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }